<template>
<section class="date-range">
  <el-date-picker
    v-model="query.beginTime"
    :picker-options="startDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="开始时间"
    type="date"
    format="yyyy年MM月dd日"
    value-format="yyyy/MM/dd 00:00:00"
    size="small"
    style="width:170px;"
    @change="onBeginTimeChanged"
  />
  <span style="font-size:.7em;color:#606266"> ～ </span>
  <el-date-picker
    v-model="query.endTime"
    :picker-options="endDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="结束时间"
    type="date"
    format="yyyy年MM月dd日"
    value-format="yyyy/MM/dd 23:59:59"
    size="small"
    style="width:170px;"
    @change="onEndTimeChanged"
  />
</section>
</template>

<script>
export default {
  name: 'CompareTimeDay',
  props: {
    query: {
      required: true,
      type: Object
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    onBeginTimeChanged () {
      this.setQueryTimes()
    },
    onEndTimeChanged () {
      this.setQueryTimes()
    },
    setQueryTimes () {
      let {query} = this
      let queryTimes = []
      let endTimeTS = new Date(query.endTime).getTime()

      for (let beginTime = new Date(query.beginTime); beginTime.getTime() <= endTimeTS; beginTime.setDate(beginTime.getDate() + 1)) {
        queryTimes.push(beginTime.format('yyyy/MM/dd'))
      }

      query.queryTimes = queryTimes
    }
  },
  created () {
    this.setQueryTimes()
    this.$emit('select-changed', true)
  }
}
</script>

<style lang="scss" scoped>
.date-range {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/Day.vue